<template>
  <!-- <div class="h-full flex items-center justify-center"> -->

  <!-- class="max-w-xl max-h-[20rem] h-full text-center bg-[#F9FAFC] w-full rounded-xl shadow flex flex-col gap-y-2 items-center justify-center px-10 absolute top-1/2 left-1/2 transform-[translate(-50%,-50%)]" -->
  <div class="h-full sm:mt-0 px-4 sm:px-0 mt-15 sm:flex sm:justify-center sm:items-center">
    <div
      class="max-w-xl h-[20rem] text-center bg-[#F9FAFC] w-full rounded-xl shadow flex flex-col gap-y-2 items-center justify-center px-10 "
    >
      <h1 class="text-3xl sm:text-4xl text-black font-bold">Form Submitted</h1>
      <p class="font-light text-black">
        Thank you for submitting the form. <br />
        Please stay tuned for further updates.
      </p>
    </div>
  </div>
  <!-- </div> -->
</template>

<script setup></script>
